import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { DataType } from '../data-type-component';
import { PlayerInfoFieldDTO } from '../shared/player-info/form-field/player-info-form-field.component';
import { MoneyDTO } from '../../../../system/system-dtos';

@Injectable()
export class DataTypeComparatorsService {
  private dataTypes: Map<DataType, (el1: any, el2: any) => number> = new Map<DataType, (el1: any, el2: any) => number>([
    [DataType.text, this.getStringComparator()],
    [DataType.number, (el1, el2): number => el1 - el2],
    [DataType.money, (el1: MoneyDTO, el2: MoneyDTO): number => (el1 ? el1.value : 0) - (el2 ? el2.value : 0)],
    [DataType.date, this.getDateComparator()],
    [DataType.date_time, this.getDateComparator()],
    [DataType.checkbox, this.getBooleanComparator()],
    [DataType.player_info, this.getPlayerComparator()],
  ]);

  private getDateComparator() {
    return (el1, el2): number => {
      if (el1 && !el2) {
        return 1;
      }
      if (!el1 && el2) {
        return -1;
      }
      return moment(el1).isAfter(moment(el2)) ? 1 : -1;
    };
  }

  private getStringComparator() {
    return (el1: string, el2: string): number => el1.localeCompare(el2);
  }

  private getBooleanComparator() {
    return (el1: boolean, el2: boolean): number => String(el1).localeCompare(String(el2));
  }

  getComparator(dataType: DataType): (el1: any, el2: any) => number {
    const comparator = this.dataTypes.get(dataType);
    return comparator || this.getStringComparator();
  }

  private getPlayerComparator() {
    return (el1: PlayerInfoFieldDTO, el2: PlayerInfoFieldDTO): number => el1?.email?.localeCompare(el2?.email);
  }
}
